export const pad2 = (n) => String(n).padStart(2, "0");

export const toDateKey = (year, month, day) =>
  `${year}-${pad2(month)}-${pad2(day)}`;

export const dateFromKey = (dateKey) => {
  const [y, m, d] = String(dateKey).split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const partsFromDate = (date) => ({
  year: date.getFullYear(),
  month: date.getMonth() + 1,
  day: date.getDate(),
  dateKey: toDateKey(date.getFullYear(), date.getMonth() + 1, date.getDate()),
});

export const todayParts = () => partsFromDate(new Date());

export const shiftDateKey = (dateKey, days) => {
  const date = dateFromKey(dateKey);
  date.setDate(date.getDate() + days);
  return partsFromDate(date);
};

export const formatLongDate = (date, locale) =>
  date.toLocaleDateString(locale, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export const formatShortDate = (date, locale) =>
  date.toLocaleDateString(locale, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
